<template>
  <div class="tw-location-container">
    <b-row class="nav-container">
      <b-col class="dropdown-ctn">
        <div>
          <b-card no-body>
            <div class="store-container">
              <div class="map-area">
                <gmap-map
                  :center="center"
                  :zoom="map_zoom"
                  style="width: 100%; height: 400px"
                >
                  <gmap-marker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    @click="showDetail(places[index])"
                  ></gmap-marker>
                </gmap-map>
              </div>
              <div class="location-area">
                <div
                  class="close-btn c-pointer"
                  @click="desktopDropdownToggle('store')"
                  v-if="!locationSearchView"
                >
                  <close-img></close-img>
                </div>
                <div
                  class="store-header pd-15"
                  v-if="
                    cur_step == 'step_state' ||
                    cur_step == 'step_city' ||
                    cur_step == 'step_place'
                  "
                >
                  <div class="geolocate-area">
                    <div class="search">
                      <gmap-autocomplete
                        class="input-auto-complete"
                        @place_changed="updatePlace"
                        placeholder="Search for a store by City, State, or Zip"
                        enable-geolocation="true"
                        :types="['(regions)']"
                      ></gmap-autocomplete>
                      <i aria-hidden="true" class="fa_search fa fa-search"></i>
                    </div>
                    <div>
                      <div class="btn-location">
                        <a
                          class="getLocation c-pointer"
                          @click.stop="getCurrentLocation()"
                        >
                          <div class="b-loc">
                            <img
                              src="./../assets/geolocation.png"
                              alt="geolocation-icon"
                            />
                            <span>Current Location</span>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="radio-area store-mobile"
                    v-if="cur_step === 'step_place'"
                  >
                    <b-form-group label="">
                      <b-form-radio-group
                        v-model="view_selector"
                        :options="options"
                        class="lbl-radio"
                        value-field="item"
                        text-field="name"
                        disabled-field="notEnabled"
                      ></b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
                <div
                  class="scroll-area"
                  :class="{
                    full: cur_step == 'step_place_detail',
                    us_city:
                      cur_step == 'step_state' || cur_step == 'step_city',
                  }"
                >
                  <div class="state-area" v-if="cur_step == 'step_state'">
                    <div class="us-area pd-15">
                      <div class="sub-lbl">UNITED STATES</div>
                      <div class="sub-states">
                        <div
                          class="lbl-state c-pointer"
                          v-for="(r, index) in this.$store.state.regions"
                          :key="index"
                          @click.stop="selRegion(r)"
                        >
                          {{ r.region }}
                        </div>
                      </div>
                    </div>
                    <div class="line-mobile md-lr15"></div>
                    <div class="international-area">
                      <div class="sub-lbl">INTERNATIONAL</div>
                      <div class="d-flex flex-column">
                        <div class="">
                          <div class="lbl-country t-bold">Canada</div>
                          <div
                            class="lbl-state flex1 c-pointer"
                            @click.stop="selRegion({ region_code: 'ON' })"
                          >
                            Ontario
                          </div>
                          <div
                            class="lbl-state flex1 c-pointer"
                            @click.stop="selRegion({ region_code: 'AB' })"
                          >
                            Alberta
                          </div>
                        </div>
                        <div class="">
                          <div class="lbl-country t-bold">Saudi Arabia</div>
                          <div
                            class="lbl-state flex1 c-pointer"
                            @click.stop="
                              selRegion({ region_code: 'Riyadh Province' })
                            "
                          >
                            Riyadh Province
                          </div>
                        </div>
                        <div class="">
                          <div class="lbl-country t-bold">
                            United Arab Emirates
                          </div>
                          <div
                            class="lbl-state flex1 c-pointer"
                            @click.stop="
                              selRegion({ region_code: 'Abu Dhabi' })
                            "
                          >
                            Dubai
                          </div>
                        </div>
                      </div>
                      <div class="line-mobile"></div>
                      <div class="up-btn-custom" style="margin-top: auto">
                        <div
                          class="btn-custom"
                          @click.stop="
                            gotoLink('https://www.tintworld.com/locations/')
                          "
                        >
                          View All Locations
                          <i aria-hidden="true" class="fa fa-angle-right"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="city-area" v-if="cur_step == 'step_city'">
                    <div class="us-area pd-15">
                      <div class="sub-lbl text-uppercase">
                        {{ sel_country }}
                      </div>
                      <div class="lbl-country t-bold">{{ sel_state }}</div>
                      <div
                        class="sub-states city"
                        v-if="this.cities.length > 0"
                      >
                        <div
                          class="lbl-state c-pointer"
                          @click.stop="selCity(c)"
                          v-for="(c, index) in this.cities"
                          :key="index"
                        >
                          {{ c.city }}
                        </div>
                      </div>
                      <div class="flex-1" v-else>
                        <div class="lbl-info">
                          There aren't any cities in this region
                        </div>
                      </div>
                      <div style="margin-top: auto">
                        <div
                          @click.stop="gotoBack('')"
                          class="btn-custom mw-200"
                        >
                          <i aria-hidden="true" class="fa fa-angle-left"></i>
                          Store Search
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="map-area store-mobile"
                    v-if="view_selector === 'map' && cur_step === 'step_place'"
                  >
                    <gmap-map
                      :center="center"
                      :zoom="6"
                      style="width: 100%; height: 400px"
                    >
                      <gmap-marker
                        :key="index"
                        v-for="(m, index) in markers"
                        :position="m.position"
                        @click="center = m.position"
                      ></gmap-marker>
                    </gmap-map>
                  </div>
                  <div class="place-area" v-if="cur_step == 'step_place'">
                    <div class="empty-result">
                      <div class="flex-1 store-results-list-container" v-if="this.places.length !== 0">
                        <div
                          class="single-result-container container p-0"
                          v-for="(p, index) in places"
                          :key="index"
                        >
                          <slot
                            name="single_result"
                            v-bind:item="p"
                            v-bind:isMyStore="isMyStore(p)"
                            v-bind:item_index="index"
                          >
                            <SingleStoreSearchResult
                              :store="p"
                              :locationSearchView="locationSearchView"
                              :isMyStore="isMyStore(p['location-id'])"
                              @showDetail="showDetail(p)"
                              @goToNewTabLink="goToNewTabLink(url)"
                              :setStore="setStore"
                            >
                            </SingleStoreSearchResult>
                          </slot>
                        </div>
                      </div>
                      <div
                        class="lbl-info pd-15 flex-1"
                        v-if="this.places.length === 0"
                      >
                        There is no result.
                      </div>
                      <!-- @TODO - Refactor the DOM here for cleaner implementation, hard to read -->
                      <div class="pd-15 go-back-container">
                        <div
                          @click.stop="gotoBack('step_city')"
                          class="btn-custom mw-200"
                        >
                          <i aria-hidden="true" class="fa fa-angle-left"></i>
                          Back to Store Search
                        </div>
                      </div>
                    </div>
                  </div>
                  <StoreDetail
                    v-if="cur_step == 'step_place_detail'"
                    :selectedPlace="selectedPlace"
                    :isMyStore="isMyStore"
                    :setStore="setStore"
                    :sprintf="sprintf"
                    :showHours="showHours"
                    :gotoLink="gotoLink"
                    :gotoBack="gotoBack"
                  />
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// import Vue from 'vue'
// import { mapMutations } from "vuex";
import { eventBus } from "../main";
import axios from "axios";
import { gmapApi } from "vue2-google-maps";
import CloseImg from "./CloseImg";
import StoreDetail from "./store-locator/StoreDetail.vue";
import { BASE_URL } from "../utils/constants";
import SingleStoreSearchResult from "@/components/store-locator/SingleStoreSearchResult";
export default {
  components: {
    CloseImg,
    SingleStoreSearchResult,
    StoreDetail,
  },
  data: () => {
    return {
      showUserLocation: true,
      searchLocation: "",
      onPageResults: null,
      cur_step: "step_state", // state | city | place | place_detail | result
      map_zoom: 6,
      center: { lat: 26.4, lng: -80.08 },
      markers: [
        {
          position: {
            lat: 26.409868200000002,
            lng: -80.0852433,
          },
        },
      ],
      cities: [],
      temp_places: [],
      places: [],
      selectedPlace: null,
      view_selector: "list",
      options: [
        { item: "list", name: "List View" },
        { item: "map", name: "Map View" },
      ],
      selected_state_results: [],
    };
  },
  props: {
    locationSearchView: Boolean,
    userLocationView: Boolean,
    search_results: {
      type: Array,
      default: () => [],
    },
  },
  created: function () {
    if(this.locationSearchView) {
      if(window.$results && window.$results !== "") {
        //console.log('Page has Hardcoded Results');
        if (window.$results.view == "country") {
          //console.log('Country View');
          this.$store.state.regions = window.$results.data;
          this.cur_step = "step_state";
        }
        if (window.$results.view == "region") {
          //console.log('Region View');
          this.getUserCurrentLocation();
          this.cities = window.$results.data;
          this.selected_state_results = window.$results.data;
          this.sel_country = "United States";
          this.sel_state = window.$results.parent;
          this.cur_step = "step_city";
        }
        if (window.$results.view == "city") {
          //console.log('City View');
          this.loadResults(window.$results.data);
        }
      }
    }
    if (this.userLocationView) {
      this.getCurrentLocation();
    }
  },
  mounted: function () {
    if(typeof window.$results == "undefined"){
      //console.log('Loading Cached Locations');
      setTimeout(() => {
        this.loadCurrentLocation();
      }, 100);
      if (this.search_results.length > 0) {
        this.loadCachedResults();
        this.cur_step = "step_place";
      } else {
        if (this.cachedSearchResults.length > 0) {
          this.loadCachedResults();
          this.cur_step = "step_place";
        }
      }
      eventBus.$on("updatedStore", (new_store) => {
        this.store = new_store;
        this.setStore(new_store);
      });
    }
  },
  computed: {
    google: gmapApi,
    myStore() {
      return this.$store.state.myStore;
    },
    cachedSearchResults() {
      return this.$store.state.user.search_results;
    },
    cachedUserLocation() {
      return this.$store.state.user.user_location;
    },
    storeView() {
      if (this.cur_step == "step_place") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    openQuoteServices() {
      this.$store.commit("OpenModal", "quote");
      this.$root.$emit("bv::show::modal", "tint-world-modal");
      var form = { type: "quote", change: "go_to", go_to: 1 };
      this.$store.commit("QuoteFormBack", form);
    },
    desktopDropdownToggle(item_label) {
      this.$emit("closeDropdown", item_label);
    },
    loadCurrentLocation() {
      if (!this.locationSearchView) {
        var cur_loc = this.$store.state.myStore;
        if (cur_loc) {
          this.center = {
            lat: cur_loc.address.coordinates.latitude,
            lng: cur_loc.address.coordinates.longitude,
          };
          this.map_zoom = 7;
          this.markers = [{ position: this.center }];
          this.selectedPlace = cur_loc;
          this.cur_step = "step_place_detail";
        }
      }
    },
    selPlace(place) {
      this.currentPlace = place;
    },
    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.map_zoom = 7;
      });
    },
    getCurrentLocation() {
      var self = this;
      axios
        .get("https://ipinfo.io/?token=762408ef747fbe")
        .then(function (response) {
          var geo = response.data.loc.split(",");
          var lat = geo[0];
          var long = geo[1];
          var userLocation = response.data;
          var sel_city = userLocation.city;
          var sel_location = userLocation.region;
          self.center = { lat: parseFloat(lat), lng: parseFloat(long) };
          self.selCity({ city: sel_city, region: sel_location });
        });
    },
    getUserCurrentLocation() {
      var self = this;
      axios
        .get("https://ipinfo.io/?token=762408ef747fbe")
        .then(function (response) {
          var geo = response.data.loc.split(",");
          var lat = geo[0];
          var long = geo[1];
          self.center = { lat: parseFloat(lat), lng: parseFloat(long) };
        });
    },
    updateCenter(location) {
      this.center = {
        lat: location.lat(),
        lng: location.lng(),
      };
    },
    pickBestType(addressComponents, priorityTypes) {
      // Ensure addressComponents is an array
      if (!Array.isArray(addressComponents)) return null;

      // Iterate through priority types
      for (const priorityType of priorityTypes) {
        // Find the first component that includes the current priority type
        const match = addressComponents.find(component =>
            component.types.includes(priorityType)
        );

        // If a match is found, return its long_name
        if (match) return match.long_name;
      }

      // If no match is found, return null
      return null;
    },
    findCityName(addressComponents){
      const PRIORITY = ['locality','sublocality','neighborhood','postal_town','colloquial_area'];
      return this.pickBestType(addressComponents, PRIORITY) || '';
    },
    findStateName(addressComponents){
      const PRIORITY = ['administrative_area_level_1','administrative_area_level_2','administrative_area_level_3'];
      return this.pickBestType(addressComponents, PRIORITY) || '';
    },
    findPostalCode(addressComponents){
      for (let component of addressComponents) {
        if (component.types.includes("postal_code")) {
          return component.long_name;
        }
      }
      return false;
    },
    updatePlace(place){
      var sel_city = "";
      var sel_location = "";
      var userLocation = {};
      let set_city = {};
      if(place && place.geometry){
        userLocation.lat = place.geometry.location.lat();
        userLocation.lon = place.geometry.location.lng();
        self.center = {
          lat: parseFloat(userLocation.lat),
          lng: parseFloat(userLocation.lon),
        };
        if(place.types.includes("postal_code") && place.types.length === 1){
          var has_postal_code = this.findPostalCode(place.address_components);
          if(has_postal_code){
            set_city.city = has_postal_code;
            set_city.region = '';
            this.selCity(set_city);
            return;
          }
        }
        if(place.address_components){
          sel_city = this.findCityName(place.address_components);
          sel_location = this.findStateName(place.address_components);
        }
        if(sel_city !== ''){
          set_city.city = sel_city;
          set_city.region = sel_location;
          this.selCity(set_city);
          return;
        } else {
          var has_other_postal_code = this.findPostalCode(place.address_components);
          if(has_other_postal_code){
            set_city.city = has_other_postal_code;
            set_city.region = '';
            this.selCity(set_city);
            return;
          }
        }
        // @TODO - Add an error state here?
        //this.selCity(set_city);
      } else {
        console.log('Could Not Determine City and State');
      }
    },
    updatePlaceLegacy(place) {
      //console.log(place);
      var sel_city = "";
      var sel_location = "";
      var userLocation = {};
      let set_city = {};
      if(place && place.geometry){
        userLocation.lat = place.geometry.location.lat();
        userLocation.lon = place.geometry.location.lng();
        if (place.address_components) {
          for (let component of place.address_components) {
            const componentType = component.types[0];
            switch (componentType) {
              case "locality":
                sel_city = component.long_name;
                break;
              case "administrative_area_level_1":
                sel_location = component.long_name;
                break;
            }
          }
        }
        if(!sel_city || sel_city == '') {
          sel_city = this.findCityName(place.address_components);
        }
        if (!sel_location || sel_location == '') {
          sel_location = this.findStateName(place.address_components);
        }
        if(sel_city !== ''){
          set_city.city = sel_city;
          set_city.region = sel_location;
        } else {
          var has_postal_code = this.findPostalCode(place.address_components);
          if(has_postal_code){
            set_city.city = has_postal_code;
            set_city.region = '';
          }
        }
        self.center = {
          lat: parseFloat(userLocation.lat),
          lng: parseFloat(userLocation.lon),
        };
        this.selCity(set_city);
      } else {
        console.log('Could Not Determine City and State');
      }
    },
    selCountry(region) {
      // let vm = this;
      axios.get(
        `${BASE_URL}/wp-json/tint-world-api/v1/get-store-regions/` + region
      );
    },
    selRegion(region) {
      let vm = this;
      axios
        .get(
          `${BASE_URL}/wp-json/tint-world-api/v1/get-store-regions/` +
            region.region_code
        )
        .then(function (response) {
          var cities = response.data;
          if (cities.length > 0) {
            if (cities.length == 1) {
              vm.selCity(cities[0]);
            } else {
              var new_makers = [];
              for (let k of cities) {
                new_makers.push({
                  position: {
                    lat: parseFloat(k.latitude),
                    lng: parseFloat(k.longitude),
                  },
                });
              }

              vm.center = new_makers[0].position;
              vm.markers = new_makers;
              vm.cities = cities;
              vm.selected_state_results = cities;
              vm.sel_country =
                region.country_code == "US"
                  ? "United States"
                  : region.country_code;
              vm.sel_state = region.region;
              vm.cur_step = "step_city";
            }
          }
        });
    },
    loadCachedResults() {
      if (this.cachedSearchResults.length == 0) {
        return;
      }
      //@TODO - Let's go ahead and trigger the locate user function below to ensure the programming triggers and we don't run into weird behavior
      //@TODO - Maybe on creation setup so the places don't auto-mount with data? Though default Vue logic should ensure this doesn't happen
      if (this.cachedUserLocation.lat == null) {
        return;
      }
      let vm = this;
      if (vm.$store.getters.cachedLocationMarkers) {
        vm.center = {
          lat: parseFloat(
            vm.$store.getters.cachedLocationMarkers[0].position.lat
          ),
          lng: parseFloat(
            vm.$store.getters.cachedLocationMarkers[0].position.lng
          ),
        };
      } else {
        vm.center = {
          lat: parseFloat(vm.cachedUserLocation.lat),
          lng: parseFloat(vm.cachedUserLocation.lng),
        };
      }
      vm.markers = vm.$store.getters.cachedLocationMarkers;
      vm.places = vm.cachedSearchResults;
      vm.cur_step = "step_place";
    },
    loadResults(results) {
      let vm = this;
      var res_places = results;

      if (res_places.results !== 0) {
        var new_makers = [];
        for (let k of res_places["nearby-locations"]) {
          new_makers.push({
            position: {
              lat: parseFloat(k.address.coordinates.latitude),
              lng: parseFloat(k.address.coordinates.longitude),
            },
          });
        }
        //vm.center = new_makers[0].position
        vm.center = {
          lat: parseFloat(res_places["search-location"].latitude),
          lng: parseFloat(res_places["search-location"].longitude),
        };
        vm.markers = new_makers;
        vm.places = res_places["nearby-locations"];
        vm.cur_step = "step_place";
      } else {
        vm.center = { lat: 26.4, lng: -80.08 };
        vm.markers = [];
        vm.places = [];
        vm.cur_step = "step_place";
      }
    },
    selCity(city) {
      let vm = this;
      let search = '';
      if (city.city) {
        search = city.city;
      }
      if (city.region) {
        search += ", " + city.region;
      }
      vm.$store
        .dispatch("getGeoResults", {
          search: { ["location-search"]: search },
        })
        .then(function () {
          vm.loadCachedResults();
        });
    },
    showDetail(place) {
      this.selectedPlace = place;
      this.cur_step = "step_place_detail";
    },
    gotoBack(step) {
      if (step === "") {
        this.center = { lat: 26.4, lng: -80.08 };
        this.map_zoom = 6;
        this.markers = [
          {
            position: {
              lat: 26.4,
              lng: -80.0852433,
            },
          },
        ];
        var cur_loc = this.$store.state.myStore;
        if (cur_loc) {
          this.center = {
            lat: cur_loc.address.coordinates.latitude,
            lng: cur_loc.address.coordinates.longitude,
          };
          this.markers = [{ position: this.center }];
          this.map_zoom = 7;
          this.selectedPlace = cur_loc;
        }
        this.cur_step = "step_state";
      } else if (step === "place") {
        if (this.places.length > 0) {
          this.cur_step = "step_place";
        } else {
          this.gotoBack("");
        }
      } else if (step === "step_city") {
        if (this.cities.length <= 1) {
          this.gotoBack("");
        } else {
          this.cur_step = "step_city";
        }
      }
    },
    sprintf(str) {
      // if(str.length.length > 3) {
      //   return str
      // }else if(str.length.length > 2){
      //   return "0"+str
      // }else if(str.length.length > 1){
      //   return "00"+str
      // }else if(str.length.length > 0){
      //   return "000"+str
      // }
      return str;
    },
    formatDay(day) {
      return day.substring(0, 3);
    },
    convertTime(strTime) {
      //  08:00
      let time_h = parseInt(strTime.substring(0, 2));
      if (time_h > 12) {
        time_h = time_h - 12;
        if (time_h > 9) {
          return time_h + "pm";
        } else {
          return time_h + "pm";
        }
      } else {
        if (time_h > 9) {
          return time_h + "am";
        } else {
          return time_h + "am";
        }
      }
    },
    formatHour(hours) {
      if (hours["openIntervals"]) {
        var tx = hours["openIntervals"][0];
        return this.convertTime(tx.start) + " - " + this.convertTime(tx.end);
      } else if (hours["isClosed"]) {
        return "Closed";
      } else {
        return "";
      }
    },
    showHours(data) {
      var html = "";
      for (const [key, value] of Object.entries(data)) {
        if (key !== "holidayHours") {
          html += '<div class="d-flex flex-row md-b2">';
          html +=
            '<span class="lbl-info t-bold w65 t-cap">' +
            this.formatDay(key) +
            '</span><span class="lbl-info">' +
            this.formatHour(value) +
            "</span>";
          html += "</div>";
        }
      }
      return html;
    },
    gotoLink(url) {
      if (url !== "") location.href = url;
    },
    goToNewTabLink(url) {
      if (url !== "") window.open(url, "_blank");
    },
    setStore(store_id) {
      if (store_id === "") {
        this.$store.commit("setStore", null);
      } else {
        const cur_place = this.places.find(
          (k) => k["location-id"] === store_id
        );
        this.$store.commit("setStore", cur_place);
        this.$store.commit("setFormLocation", cur_place);
      }
      this.$gtm.trackEvent({
        event: "set_user_store",
        category: "Store Locator",
        action: "User Set Specific Store",
        label: store_id,
        noninteraction: false,
      });
      this.$emit("setNewStore", store_id);
    },
    isMyStore(store_id) {
      if (this.myStore && this.myStore["location-id"] === store_id) {
        return true;
      } else {
        return false;
      }
    },
  },
};
//@TODO - Add v-model with data code to control the b-tabs: https://bootstrap-vue.org/docs/components/tabs#advanced-examples
</script>

<style scoped>
.go-back-container {
  position: absolute;
  bottom: 0;
  background: #F3F3F3;
  width: 100%;
}
.store-results-list-container {
  padding-bottom:75px;
}

.open-quote-ctr {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  /* justify-content: space-arou; */
  cursor: pointer;
  gap: 10px;
  height: fit-content;
  align-self: center;
}
.open-quote-txt {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  font-family: "Font Awesome 5 Pro" !important;
}
</style>
